// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterInvitationsWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsRenterInvitationsWebApiHandler_inviteCoapplicant,
  CappsRenterInvitationsWebApiHandler_removeCoapplicant,
} from '@zg-rentals/ts-capps-client';

import type {
  InviteCoapplicantWebApiRequestDto,
  InviteCoapplicantWebApiResponseDto,
  RemoveCoapplicantWebApiRequestDto,
} from '@zg-rentals/ts-capps-client';

export interface CappsRenterInvitationsWebApiHandler_inviteCoapplicant_Args {
  postData: InviteCoapplicantWebApiRequestDto;
}

export type CappsRenterInvitationsWebApiHandler_inviteCoapplicant_Options = UseMutationOptions<
  InviteCoapplicantWebApiResponseDto,
  unknown,
  CappsRenterInvitationsWebApiHandler_inviteCoapplicant_Args
>;

export const useCappsRenterInvitationsWebApiHandler_inviteCoapplicant = ({
  httpClient,
  ...options
}: Omit<CappsRenterInvitationsWebApiHandler_inviteCoapplicant_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterInvitationsWebApiHandler_inviteCoapplicant_Args) =>
      CappsRenterInvitationsWebApiHandler_inviteCoapplicant(args.postData, httpClient),
  });
};

export interface CappsRenterInvitationsWebApiHandler_removeCoapplicant_Args {
  postData: RemoveCoapplicantWebApiRequestDto;
}

export type CappsRenterInvitationsWebApiHandler_removeCoapplicant_Options = UseMutationOptions<
  void,
  unknown,
  CappsRenterInvitationsWebApiHandler_removeCoapplicant_Args
>;

export const useCappsRenterInvitationsWebApiHandler_removeCoapplicant = ({
  httpClient,
  ...options
}: Omit<CappsRenterInvitationsWebApiHandler_removeCoapplicant_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterInvitationsWebApiHandler_removeCoapplicant_Args) =>
      CappsRenterInvitationsWebApiHandler_removeCoapplicant(args.postData, httpClient),
  });
};
